<!-- 
  kpi POR DIRECTOR

  CADA DEPARTAMENTO TIENE SU PROPIO KPI, EL CUAL SE DIVIDIRA POR ESCUELA

  DEPARTAMENTO: RH, COMERCIAL, FINANZAS, TI, OPERACIONES

  ESCUELA: FAST, INBI

  Agregar colorimetría
  Amarillo: 70% - 80%
  Verde: > 80%  
  Rojo: 0% - 70%
-->
<template>
  <v-container class="mt-5 ml-2" fluid >
    <v-row>
      <v-col cols="12">
        <v-card class="transparent elevation-0">
          <v-card-title primary-title class="text-subtitle-1">
            Kpi de mi departamento
            <v-spacer></v-spacer>

            <v-btn 
            	color="primary"
            	@click="initialize()" 
            	small
            	tile
            >
          		Consultar
          	</v-btn>
          </v-card-title>


          <!-- Contenido de la pagina -->
          <v-card-text>

          	<!-- Filtros -->
          	<v-row>
              <!-- <v-col cols="12" sm="4" lg="4" xl="3">
                <v-autocomplete
                  filled
                  dense
                  clearable
                  v-model="cicloInf"
                  :items="ciclos"
                  label="Selecciona ciclo actual"
                  persistent-hint
                  hide-details
                  return-object
                  item-text="ciclo"
                  item-value="id_ciclo"
                >
                </v-autocomplete>
              </v-col> -->

              <v-col cols="12" sm="4" lg="3" xl="2">
                <v-text-field
                  label="Fecha de incio"
                  filled
                  dense
                  clearable
                  v-model="fechaini"
                  type="date"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="4" lg="3" xl="2">
                <v-text-field
                  label="Fecha final"
                  filled
                  dense
                  clearable
                  v-model="fechafin"
                  type="date"
                ></v-text-field>
              </v-col>
            </v-row>

          	<v-row>
          		<v-col cols="12">
		            <v-row>

                  <!-- Operaciones ventas -->
		            	<v-col cols="12" md="4" v-if="visible">
		            		<v-card color="shadowCard text-center" class="fill-height d-flex flex-column">

                      <v-system-bar
                        height="35"
                        color="green"
                        class="white--text px-2"
                      >
                        <v-spacer></v-spacer>
                        <span class="text-h4 ma-2">Op. Inscritos NI  <v-icon large color="white">mdi-check</v-icon> </span>
                        <v-spacer></v-spacer>
                      </v-system-bar>
                      
                      <v-card-text class="black--text text-h6 pt-1">
                        {{ ciclo }}
		            		  </v-card-text>

		            		  <v-card-text>
                        <v-row>
                          <v-col cols="12" md="6" lg="6">
                            <v-card color="shadowCard text-center" class="fill-height d-flex flex-column">
                              <v-card-title primary-title>
                                <v-spacer></v-spacer>
                                <div><v-chip color="red" dark>Fast</v-chip></div>
                                <v-spacer></v-spacer>
                              </v-card-title>
                              <v-card-text>
                                <v-progress-circular
                                  :rotate="90"
                                  :size="160"
                                  :width="15"
                                  color="grey"
                                  :value="avanceActualesFast"
                                  @click="tablaVentasCiclo = tablaFast, dialogVentasCiclo = true, tablaVentaCicloInbi = false "
                                >
                                  <span class="text-h3 red--text"><b>{{ totalVentasFast - ventasCambiosFast }}</b></span>
                                </v-progress-circular>
                                <v-row class="align-center mt-4 text-h6">
                                  <v-col cols="6">
                                    <div v-if="ciclo">NI {{ ciclo.replace('CICLO ', '') }}</div>
                                    <div>{{ metaFast }}</div>
                                  </v-col>

                                  <v-col cols="6">
                                    <div>Faltan</div>
                                    <div> {{ metaFast - (totalVentasFast - ventasCambiosFast) }} </div>
                                  </v-col>

                                  <v-col cols="12" class="grey--text text-subtitle-1">Cambios: {{ ventasCambiosFast }}</v-col>
                                </v-row>

                              </v-card-text>
                            </v-card>
                          </v-col>

                          <v-col cols="12" md="6" lg="6">
                            <v-card color="shadowCard text-center" class="fill-height d-flex flex-column">
                              <v-card-title primary-title>
                                <v-spacer></v-spacer>
                                <div><v-chip color="blue" dark>Inbi</v-chip></div>
                                <v-spacer></v-spacer>
                              </v-card-title>

                              <v-card-text>
                                <v-progress-circular
                                  @click="tablaVentasCiclo = tablaInbi, dialogVentasCiclo = true, tablaVentaCicloInbi = true "
                                  :rotate="90"
                                  :size="160"
                                  :width="15"
                                  :value="avanceActualesInbi"
                                  color="grey"
                                >
                                  <div class="text-h3 blue--text"><b>{{ totalVentasInbi - ventasCambiosInbi }}</b></div>
                                </v-progress-circular>
                                <v-row class="align-center mt-4 text-h6">
                                  <v-col cols="6">
                                    <div v-if="ciclo">NI {{ ciclo.replace('CICLO ', '') }}</div>
                                    <div>{{ metaInbi }}</div>
                                  </v-col>

                                  <v-col cols="6">
                                    <div>Faltan</div>
                                    <div>{{ metaInbi - (totalVentasInbi - ventasCambiosInbi) }} </div>
                                  </v-col>
                                  <v-col cols="12" class="grey--text text-subtitle-1">Cambios: {{ ventasCambiosInbi }}</v-col>

                                </v-row>

                              </v-card-text>

                            </v-card>
                          </v-col>
                        </v-row>
                      </v-card-text>
		            		  <v-card-text class="mt-auto">
		            		    Valor aceptable: 
		            		  </v-card-text>
		            			
		            		</v-card>
		            	</v-col>

                  <v-col cols="12" md="4" v-if="visible">
		            		<v-card color="shadowCard text-center" class="fill-height d-flex flex-column">

                      <v-system-bar
                        height="35"
                        color="blue"
                        class="white--text"
                      >
                        <v-spacer></v-spacer>
                        <span class="text-h4 ma-2">Operaciones - %RI <v-icon large color="white">mdi-check</v-icon> </span>
                        <v-spacer></v-spacer>
                      </v-system-bar>

                      <v-card-text class="black--text text-h6 pt-1">
                        {{ ciclo }}
		            		  </v-card-text>
		            		  <v-card-text>
                        <v-row>
                          <v-col cols="12" md="6" lg="6">
                            <v-card color="shadowCard text-center" class="fill-height d-flex flex-column">
                              <v-card-title primary-title>
                                <v-spacer></v-spacer>
                                <div><v-chip color="red" dark>Fast</v-chip></div>
                                <v-spacer></v-spacer>
                              </v-card-title>
                              <v-card-text>
                                <v-progress-circular
                                  v-if="resultadoRi"
                                  :rotate="90"
                                  :size="160"
                                  :width="15"
                                  color="grey"
                                  :value="( resultadoRi.riPlantelesFast[resultadoRi.riPlantelesFast.length - 1].porcentajeAvance / 93 ) * 100"
                                >
                                  <span class="text-h3 red--text"><b>{{ resultadoRi.riPlantelesFast[resultadoRi.riPlantelesFast.length - 1].porcentajeAvance }}</b></span>
                                </v-progress-circular>
                                <v-row class="align-center mt-4 text-h6">
                                  <v-col cols="6">
                                    <div v-if="ciclo">Meta {{ ciclo.replace('CICLO ', '') }}</div>
                                    <div>{{ 93 + ' %' }}</div>
                                  </v-col>

                                  <v-col cols="6">
                                    <div>Faltan</div>
                                    <div v-if="resultadoRi"> {{ ( 93 - (resultadoRi.riPlantelesFast[resultadoRi.riPlantelesFast.length - 1].porcentajeAvance)).toFixed( 2 ) + ' %' }} </div>
                                  </v-col>
                                  <v-col cols="12" class="white--text text-subtitle-1">.</v-col>

                                </v-row>
                              </v-card-text>
                            </v-card>
                          </v-col>

                          <v-col cols="12" md="6" lg="6">
                            <v-card color="shadowCard text-center" class="fill-height d-flex flex-column">
                              <v-card-title primary-title>
                                <v-spacer></v-spacer>
                                <div><v-chip color="blue" dark>Inbi</v-chip></div>
                                <v-spacer></v-spacer>
                              </v-card-title>

                              <v-card-text>
                                <v-progress-circular
                                  v-if="resultadoRi"
                                  :rotate="90"
                                  :size="160"
                                  :width="15"
                                  color="grey"
                                  :value="( resultadoRi.riPlantelesInbi[resultadoRi.riPlantelesInbi.length - 1].porcentajeAvance / 93 ) * 100"
                                >
                                  <span class="text-h3 blue--text"><b>{{ resultadoRi.riPlantelesInbi[resultadoRi.riPlantelesInbi.length - 1].porcentajeAvance }}</b></span>
                                </v-progress-circular>
                                <v-row class="align-center mt-4 text-h6">
                                  <v-col cols="6">
                                    <div v-if="ciclo">Meta {{ ciclo.replace('CICLO ', '') }}</div>
                                    <div>{{ 93 + ' %' }}</div>
                                  </v-col>

                                  <v-col cols="6">
                                    <div>Faltan</div>
                                    <div v-if="resultadoRi"> {{ ( 93 - (resultadoRi.riPlantelesInbi[resultadoRi.riPlantelesInbi.length - 1].porcentajeAvance)).toFixed( 2 ) + ' %' }} </div>
                                  </v-col>

                                  <v-col cols="12" class="white--text text-subtitle-1">.</v-col>

                                </v-row>

                              </v-card-text>

                            </v-card>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text>
		            		    Valor aceptable: 
		            		  </v-card-text>
		            		</v-card>
		            	</v-col>

                  <v-col cols="12" md="4" v-if="visible">
		            		<v-card color="shadowCard text-center" class="fill-height d-flex flex-column">

                      <v-system-bar
                        height="35"
                        color="pink"
                        class="white--text"
                      >
                        <v-spacer></v-spacer>
                        <span class="text-h4 ma-2">Operaciones - $$</span>
                        <v-spacer></v-spacer>
                      </v-system-bar>

                      <v-card-text class="black--text text-h6 pt-1">
                        {{ ciclo }}
		            		  </v-card-text>
		            		  <v-card-text>
                        <v-row>
                          <v-col cols="12" md="6" lg="6">
                            <v-card color="shadowCard text-center" class="fill-height d-flex flex-column">
                              <v-card-title primary-title>
                                <v-spacer></v-spacer>
                                <div><v-chip color="red" dark>Fast</v-chip></div>
                                <v-spacer></v-spacer>
                              </v-card-title>
                              <v-card-text>
                                <v-progress-circular
                                  :rotate="100"
                                  :size="160"
                                  :width="15"
                                  color="grey"
                                  :value="metamoney.avance_fast"
                                >
                                  <span class="text-h4 red--text"><b>{{ metamoney.avance_fast }}</b></span>
                                </v-progress-circular>
                                <v-row class="align-center mt-4 text-h6">
                                  <v-col cols="6">
                                    <div v-if="ciclo">Meta {{ ciclo.replace('CICLO ', '') }}</div>
                                    <div> 100% </div>
                                  </v-col>

                                  <v-col cols="6">
                                    <div>Faltan</div>
                                    <div > {{ metamoney.faltante_fast }} % </div>
                                  </v-col>
                                  <v-col cols="12" class="white--text text-subtitle-1">.</v-col>

                                </v-row>
                              </v-card-text>
                            </v-card>
                          </v-col>

                          <v-col cols="12" md="6" lg="6">
                            <v-card color="shadowCard text-center" class="fill-height d-flex flex-column">
                              <v-card-title primary-title>
                                <v-spacer></v-spacer>
                                <div><v-chip color="blue" dark>Inbi</v-chip></div>
                                <v-spacer></v-spacer>
                              </v-card-title>

                              <v-card-text>
                                <v-progress-circular
                                  :rotate="100"
                                  :size="160"
                                  :width="15"
                                  color="grey"
                                  :value="metamoney.avance_inbi"
                                >
                                  <span class="text-h4 blue--text"><b>{{ metamoney.avance_inbi }}</b></span>
                                </v-progress-circular>
                                <v-row class="align-center mt-4 text-h6">
                                  <v-col cols="6">
                                    <div v-if="ciclo">Meta {{ ciclo.replace('CICLO ', '') }}</div>
                                    <div> 100% </div>
                                  </v-col>

                                  <v-col cols="6">
                                    <div>Faltan</div>
                                    <div > {{ metamoney.faltante_inbi }} % </div>
                                  </v-col>

                                  <v-col cols="12" class="white--text text-subtitle-1">.</v-col>

                                </v-row>

                              </v-card-text>

                            </v-card>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text>
		            		    Valor aceptable: 
		            		  </v-card-text>
		            		</v-card>
		            	</v-col>

                  <!-- Departamento de Recursos Humanos -->
		            	<v-col cols="12" md="6" lg="4">
		            		<v-card color="shadowCard text-center" class="fill-height d-flex flex-column">

                      <!-- Tiulo del departamento -->
                      <v-system-bar
                        height="35"
                        color="yellow"
                        class="black--text"
                      >
                        <v-spacer></v-spacer>
                        <span class="text-h4 ma-2">RH - %Ocupación <v-icon large color="black" @click="exportExcel( vacantesExcelRH  , 'RH')">mdi-microsoft-excel</v-icon> </span>
                        <v-spacer></v-spacer>
                      </v-system-bar>

                      <!-- Porcentaje de ocupación -->
		            		  <v-card-title primary-title class="flex-column align-center">
		            		    <v-row class="ocupacion-row">
                          <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <v-card 
		            		          color="red darken-2" 
		            		          :color="rhOcupacionFast.percent_ocupacion >= 80 ? 'green' : rhOcupacionFast.percent_ocupacion >= 70 ? 'yellow' : 'grey'" 
		            		          :dark="rhOcupacionFast.percent_ocupacion >= 80 ? true : rhOcupacionFast.percent_ocupacion >= 70 ? false : true" 
		            		          class="ocupacion-card pa-4 text-center text-h4 shadowCard">
		            		          {{ rhOcupacionFast.percent_ocupacion }} %
		            		        </v-card>
		            		        <span class="ocupacion-label"><v-chip color="red" dark>Fast</v-chip></span>
		            		      </v-col>
		            		      <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <v-card 
		            		          color="blue darken-2" 
		            		          :color="rhOcupacionInbi.percent_ocupacion >= 80 ? 'green' : rhOcupacionInbi.percent_ocupacion >= 70 ? 'yellow' : 'grey'" 
		            		          :dark="rhOcupacionInbi.percent_ocupacion >= 80 ? true : rhOcupacionInbi.percent_ocupacion >= 70 ? false : true" 
		            		          class="ocupacion-card pa-4 text-center text-h4 shadowCard">
		            		          {{ rhOcupacionInbi.percent_ocupacion }} %
		            		        </v-card>
		            		        <span class="ocupacion-label"><v-chip color="blue" dark>Inbi</v-chip></span>
		            		      </v-col>
		            		    </v-row>
		            		    <v-row class="ocupacion-row">
		            		      <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <v-card 
		            		          color="blue darken-2" 
		            		          :color="rhOcupacionCorpo.percent_ocupacion >= 80 ? 'green' : rhOcupacionCorpo.percent_ocupacion >= 70 ? 'yellow' : 'grey'" 
		            		          :dark="rhOcupacionCorpo.percent_ocupacion >= 80 ? true : rhOcupacionCorpo.percent_ocupacion >= 70 ? false : true" 
		            		          class="ocupacion-card pa-4 text-center text-h4 shadowCard">
		            		          {{ rhOcupacionCorpo.percent_ocupacion }} %
		            		        </v-card>
		            		        <span class="ocupacion-label">Coorporativo</span>
		            		      </v-col>
		            		      <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <v-card 
		            		          color="red darken-2" 
		            		          :color="rhOcupacionTodo.percent_ocupacion >= 80 ? 'green' : rhOcupacionTodo.percent_ocupacion >= 70 ? 'yellow' : 'grey'" 
		            		          :dark="rhOcupacionTodo.percent_ocupacion >= 80 ? true : rhOcupacionTodo.percent_ocupacion >= 70 ? false : true" 
		            		          class="ocupacion-card pa-4 text-center text-h4 shadowCard">
		            		          {{ rhOcupacionTodo.percent_ocupacion }} %
		            		        </v-card>
		            		        <span class="ocupacion-label">General</span>
		            		      </v-col>
		            		    </v-row>
		            		  </v-card-title>
                    
		            		  <v-card-text class="mt-auto">
		            		    Valor aceptable: 
		            		  </v-card-text>

		            		  <v-btn 
		            		  	color="blue"
		            		  	absolute
		            		  	top
		            		  	right
		            		  	icon
		            		  	@click="dialogRh.estatus = true"
		            		  >
		            				<v-icon>mdi-information-outline</v-icon>
		            			</v-btn>
		            		</v-card>
		            	</v-col>

                  <!-- Departamento de Comercial -->
		            	<v-col cols="12" md="6" lg="4" v-if="visible">
		            		<v-card color="shadowCard text-center" class="fill-height d-flex flex-column">

                      <v-system-bar
                        height="35"
                        color="yellow"
                        class="black--text"
                      >
                        <v-spacer></v-spacer>
                        <span class="text-h4 ma-2">Comercial <v-icon large color="black">mdi-check</v-icon> </span>
                        <v-spacer></v-spacer>
                      </v-system-bar>

                      <v-card-title primary-title class="flex-column align-center">
		            		    <v-row class="ocupacion-row">
                          <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <v-card 
		            		          color="grey" 
		            		          class="ocupacion-card pa-4 text-center text-h3 shadowCard white--text">
		            		          {{ prospectosFast.length }}
		            		        </v-card>
		            		        <span class="ocupacion-label"><v-chip color="red" dark>Fast</v-chip></span>
		            		      </v-col>
		            		      <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <v-card 
		            		          color="grey" 
		            		          class="ocupacion-card pa-4 text-center text-h3 shadowCard white--text">
		            		          {{ prospectosInbi.length }}
		            		        </v-card>
		            		        <span class="ocupacion-label"><v-chip color="blue" dark>Inbi</v-chip></span>
		            		      </v-col>
		            		    </v-row>
		            		  </v-card-title>

		            		  <v-card-text class="mt-auto">
		            		    Valor aceptable: 
		            		  </v-card-text>

		            			<v-btn 
		            		  	color="blue"
		            		  	absolute
		            		  	top
		            		  	right
		            		  	icon
		            		  	@click="dialogComercial.estatus = true"
		            		  >
		            				<v-icon>mdi-information-outline</v-icon>
		            			</v-btn>
		            		</v-card>
		            	</v-col>

                  <!-- Departamento de TI -->
		            	<v-col cols="12" md="6" lg="4" v-if="visible">
		            		<v-card color="shadowCard text-center" class="fill-height d-flex flex-column">

                      <v-system-bar
                        height="35"
                        color="yellow"
                        class="black--text"
                      >
                        <v-spacer></v-spacer>
                        <span class="text-h4 ma-2">TI</span>
                        <v-spacer></v-spacer>
                      </v-system-bar>

		            		  <v-card-title primary-title>
		            		  	<v-spacer></v-spacer>
		            		    <div> 
		            		    	<v-card color="grey" dark class="pa-4 text-center text-h3 shadowCard">
		            		    	  {{ ti.kpi_ti }} %
		            		    	</v-card>
		            		    </div>
		            		  	<v-spacer></v-spacer>
		            		  </v-card-title>
		            		  
		            		  <v-card-text class="mt-auto">
		            		    Valor aceptable: 
		            		  </v-card-text>

		            			<v-btn 
		            		  	color="blue"
		            		  	absolute
		            		  	top
		            		  	right
		            		  	icon
		            		  	@click="dialogTI.estatus = true"
		            		  >
		            				<v-icon>mdi-information-outline</v-icon>
		            			</v-btn>
		            		</v-card>
		            	</v-col>

                  <!-- Departamento de Finanzas -->
		            	<v-col cols="12" md="6" lg="4" v-if="visible">
		            		<v-card color="shadowCard text-center" class="fill-height d-flex flex-column">

                      <v-system-bar
                        height="35"
                        color="yellow"
                        class="black--text"
                      >
                        <v-spacer></v-spacer>
                        <span class="text-h4 ma-2">Finanzas</span>
                        <v-spacer></v-spacer>
                      </v-system-bar>

                      <v-card-title primary-title class="flex-column align-center">

                        <v-row class="ocupacion-row">
		            		      <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
                            <span class="ocupacion-label"><v-chip color="red" dark>Fast</v-chip></span>
		            		      </v-col>
		            		      <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <span class="ocupacion-label"><v-chip color="blue" dark>Inbi</v-chip></span>
		            		      </v-col>
		            		    </v-row>

		            		    <v-row class="ocupacion-row">
		            		      <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <v-card 
		            		          color="grey" 
                              dark
		            		          class="ocupacion-card pa-5 text-center text-h4 shadowCard">
		            		          {{ finanzas.egresoFast }}
		            		        </v-card>
		            		        <span class="ocupacion-label">Egresos</span>
		            		      </v-col>
		            		      <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <v-card 
		            		          color="grey" 
                              dark
		            		          class="ocupacion-card pa-5 text-center text-h4 shadowCard">
		            		          {{ finanzas.egresoInbi }}
		            		        </v-card>
		            		        <span class="ocupacion-label">Egreso</span>
		            		      </v-col>
		            		    </v-row>

                        <v-row class="ocupacion-row">
		            		      <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <v-card 
		            		          color="grey" 
                              dark
		            		          class="ocupacion-card pa-5 text-center text-h4 shadowCard">
		            		          {{ finanzas.ingresoValidadoFast }}
		            		        </v-card>
		            		        <span class="ocupacion-label">Ingreso</span>
		            		      </v-col>
		            		      <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <v-card 
		            		          color="grey" 
                              dark
		            		          class="ocupacion-card pa-5 text-center text-h4 shadowCard">
		            		          {{ finanzas.ingresoValidadoInbi }}
		            		        </v-card>
		            		        <span class="ocupacion-label">Ingreso</span>
		            		      </v-col>
		            		    </v-row>
		            		  </v-card-title>


		            		  
		            		  <v-card-text class="mt-auto">
		            		    Valor aceptable: 
		            		  </v-card-text>

		            			<v-btn 
		            		  	color="blue"
		            		  	absolute
		            		  	top
		            		  	right
		            		  	icon
		            		  	@click="dialogFinanzas.estatus = true"
		            		  >
		            				<v-icon>mdi-information-outline</v-icon>
		            			</v-btn>
		            		</v-card>
		            	</v-col>

                  <!-- Operaciones - Clases correctas -->
		            	<v-col cols="12" md="12" lg="4" v-if="visible">
		            		<v-card color="shadowCard text-center" class="fill-height d-flex flex-column">

                      <v-system-bar
                        height="35"
                        color="yellow"
                        class="black--text"
                      >
                        <v-spacer></v-spacer>
                        <span class="text-h4 ma-2">Operaciones - Clases</span>
                        <v-spacer></v-spacer>
                      </v-system-bar>

                      <v-card-title primary-title class="flex-column align-center">
		            		    <v-row class="ocupacion-row">
		            		      <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <v-card 
		            		          color="grey" 
                              dark
		            		          class="ocupacion-card pa-4 text-center text-h3 shadowCard">
		            		          {{ 0 }} %
		            		        </v-card>
		            		        <span class="ocupacion-label"><v-chip color="red" dark>Fast</v-chip></span>
		            		      </v-col>
		            		      <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <v-card 
		            		          color="grey" 
                              dark
		            		          class="ocupacion-card pa-4 text-center text-h3 shadowCard">
		            		          {{ 0 }} %
		            		        </v-card>
		            		        <span class="ocupacion-label"><v-chip color="blue" dark>Inbi</v-chip></span>
		            		      </v-col>
		            		    </v-row>
		            		  </v-card-title>

		            		  <v-card-text class="mt-auto">
		            		    Valor aceptable: 
		            		  </v-card-text>

		            			<v-btn 
		            		  	color="blue"
		            		  	absolute
		            		  	top
		            		  	right
                        class="mt-0"
		            		  	icon
		            		  	@click="dialogOperacionesClases.estatus = true"
		            		  >
		            				<v-icon>mdi-information-outline</v-icon>
		            			</v-btn>
		            		</v-card>
		            	</v-col>

                  <!-- Operaciones - Clases correctas -->
		            	<v-col cols="12" md="12" lg="4" v-if="visible">
		            		<v-card color="shadowCard text-center" class="fill-height d-flex flex-column">

                      <v-system-bar
                        height="35"
                        color="yellow"
                        class="black--text"
                      >
                        <v-spacer></v-spacer>
                        <span class="text-h4 ma-2">Control I. - Procesos</span>
                        <v-spacer></v-spacer>
                      </v-system-bar>

		            		  <v-card-title primary-title class="flex-column align-center">
		            		    <v-row class="ocupacion-row">
		            		      <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <v-card 
		            		          color="grey" 
                              dark
		            		          class="ocupacion-card pa-4 text-center text-h3 shadowCard">
		            		          {{ 0 }} %
		            		        </v-card>
		            		        <span class="ocupacion-label"><v-chip color="red" dark>Fast</v-chip></span>
		            		      </v-col>
		            		      <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <v-card 
		            		          color="grey" 
                              dark
		            		          class="ocupacion-card pa-4 text-center text-h3 shadowCard">
		            		          {{ 0 }} %
		            		        </v-card>
		            		        <span class="ocupacion-label"><v-chip color="blue" dark>Inbi</v-chip></span>
		            		      </v-col>
		            		    </v-row>
		            		  </v-card-title>
		            		  
		            		  <v-card-text class="mt-auto">
		            		    Valor aceptable: 
		            		  </v-card-text>

		            			<v-btn 
		            		  	color="blue"
		            		  	absolute
		            		  	top
		            		  	right
                        class="mt-0"
		            		  	icon
		            		  	@click="dialogOperacionesClases.estatus = true"
		            		  >
		            				<v-icon>mdi-information-outline</v-icon>
		            			</v-btn>
		            		</v-card>
		            	</v-col>

                  <!-- Departamento de TI -->
		            	<v-col cols="12" md="6" lg="4" v-if="visible">
		            		<v-card color="shadowCard text-center" class="fill-height d-flex flex-column">

                      <v-system-bar
                        height="35"
                        color="yellow"
                        class="black--text"
                      >
                        <v-spacer></v-spacer>
                        <span class="text-h4 ma-2">Mantenimiento</span>
                        <v-spacer></v-spacer>
                      </v-system-bar>

		            		  <v-card-title primary-title>
		            		  	<v-spacer></v-spacer>
		            		    <div> 
		            		    	<v-card color="grey" dark class="pa-4 text-center text-h3 shadowCard">
		            		    	  {{ mantenimiento.kpi_mantenimiento }} %
		            		    	</v-card>
		            		    </div>
		            		  	<v-spacer></v-spacer>
		            		  </v-card-title>
		            		  
		            		  <v-card-text class="mt-auto">
		            		    Valor aceptable: 
		            		  </v-card-text>

		            			<v-btn 
		            		  	color="blue"
		            		  	absolute
		            		  	top
		            		  	right
		            		  	icon
		            		  	@click="dialogTI.estatus = true"
		            		  >
		            				<v-icon>mdi-information-outline</v-icon>
		            			</v-btn>
		            		</v-card>
		            	</v-col>

		            </v-row>
          		</v-col>
          	</v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- ZONA DE DESGLOSES -->

    <!-- RH -->
    <JefeRecursos   
    	v-if="dialogRh.estatus"
    	:dialogRh="dialogRh"
    	:rh="rh"
    	:cicloInf="cicloInf"
			:fechaini="fechaini"
			:fechafin="fechafin"
    />

    <!-- COMERCIAL -->
    <JefeComercial   
    	v-if="dialogComercial.estatus"
    	:dialogComercial="dialogComercial"
    	:totalFastM="totalFastM"
    	:totalInbiM="totalInbiM"
    	:cicloInf="cicloInf"
			:fechaini="fechaini"
			:fechafin="fechafin"
    />

    <!-- Finanzas -->
    <JefeFinanzas   
    	v-if="dialogFinanzas.estatus"
    	:dialogFinanzas="dialogFinanzas"
    	:finanzas="finanzas"
    	:cicloInf="cicloInf"
			:fechaini="fechaini"
			:fechafin="fechafin"
    />

    <!-- TI -->
    <JefeTI   
    	v-if="dialogTI.estatus"
    	:dialogTI="dialogTI"
    	:finanzas="finanzas"
    	:cicloInf="cicloInf"
			:fechaini="fechaini"
			:fechafin="fechafin"
    />

    <!-- TI -->
    <JefeOperaciones   
    	v-if="dialogOperaciones.estatus"
    	:dialogOperaciones="dialogOperaciones"
    	:finanzas="finanzas"
    	:cicloInf="cicloInf"
			:fechaini="fechaini"
			:fechafin="fechafin"
    />

    <!-- TI -->
    <JefeOperacionesClases   
    	v-if="dialogOperacionesClases.estatus"
    	:dialogOperacionesClases="dialogOperacionesClases"
    	:finanzas="finanzas"
    	:cicloInf="cicloInf"
			:fechaini="fechaini"
			:fechafin="fechafin"
    />

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>
<script>
import axios from 'axios';

  import { mapGetters } from 'vuex'
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

  // COMPONENTES PARA EL DESGLOSE
  import JefeRecursos          from '@/components/kpi/JefeRecursos'
  import JefeComercial         from '@/components/kpi/JefeComercial'
  import JefeFinanzas          from '@/components/kpi/JefeFinanzas'
  import JefeTI                from '@/components/kpi/JefeTI'
  import JefeOperaciones       from '@/components/kpi/JefeOperaciones'
  import JefeOperacionesClases from '@/components/kpi/JefeOperacionesClases'

  import XLSX from 'xlsx'

  export default {

    components:{
      Alerta,
      carga,
      JefeRecursos,
      JefeComercial,
      JefeFinanzas,
      JefeTI,
      JefeOperaciones,
      JefeOperacionesClases,
    },

    mixins: [ validarErrores, funcionesExcel ],

    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,


			ciclos:[],
      cicloInf:null,
      cicloSup:null,

      dialogAlumnos:false,

      headers: [
        { text: 'Vendedora'    , value: 'vendedora'  },
        { text: 'I completo'   , value: 'completos'  },
      ],

      desserts: [],

      fechaini:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      fechafin:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      totalInbi:0,
      totalFast:0,

      headers2: [
        { text: 'Vendedora'       , value: 'nombre_completo'       },
        { text: 'Mat. Nvas. Liq.' , value: 'matriculas_liquidadas' },
      ],

      ciclo: null,

      rh: { },
      totalFast: 0,
			totalInbi: 0,
			finanzas:{},
			totalFastM: 0,
			totalInbiM: 0,

			dialogRh:{
				estatus: false
			},
			dialogComercial:{
				estatus: false
			},
			dialogFinanzas:{
				estatus: false
			},
			dialogTI:{
				estatus: false
			},

      dialogOperacionesClases:{
        estatus: false
      },
			rhAuxi:{},

			totalFastRI: 1.3,
			totalInbiRI: 1.8,

			dialogOperaciones:{
				estatus: false
			},

      prospectosInbi: [],
      prospectosFast: [],

      rhOcupacionInbi: { percent_ocupacion: 0 },
      rhOcupacionFast: { percent_ocupacion: 0 },
      rhOcupacionCorpo: { percent_ocupacion: 0 },
      rhOcupacionTodo:{ percent_ocupacion: 0 },
      ti: { total_tickets: 0, tickets_cerrados: 0, kpi_ti: 0 },
      mantenimiento: { kpi_mantenimiento: 0 },
      finanzas: { egresoInbi: 0, egresoFast: 0, ingresoValidadoInbi: 0, ingresoValidadoFast: 0 },
      metamoney: { avance_fast: 0, avance_inbi: 0, faltante_fast: 0, faltante_inbi: 0 },

      dialogOcupacionRh:{
        estatus: false
      },

      // Sección de operaciones
      dataTablaFastUno:[],
      dataTablaInbiUno:[],
      dataTablaFastDos:[],
      ciclo: null,
      id_ciclo: null,
      id_ciclo_relacionado: null,
      metas: [],
      resultadoRi: null,
      resultadoRiFiltro: [],
      clasesInbiHoy: [],
      clasesFastHoy: [],
      clasesInbiCorrectas: 0,
      clasesInbiTotal: 0,
      clasesFastCorrectas: 0,
      clasesFastTotal: 0,
      vacantesExcelRH:[],
      visible: false,
    }),

    computed: {
      ...mapGetters('login', ['getdatosUsuarioERPERP', 'getLogeado', 'getEscuela','drawer2','getEstatusLlamada','getNuevosProspectos']),

      avanceActualesFast() {
        if( this.dataTablaFastUno.length > 0 ) {
          return (( this.dataTablaFastUno[ this.dataTablaFastUno.length - 1 ].total / this.dataTablaFastUno[ this.dataTablaFastUno.length - 1 ].meta  )*100)
        }
        else {
          return 0
        }
      },

      totalVentasFast() {
        if( this.dataTablaFastUno.length > 0 ) {
          return this.dataTablaFastUno[ this.dataTablaFastUno.length - 1 ].total
        }
        else {
          return 0
        }
      },

      totalVentasInbi() {
        if( this.dataTablaInbiUno.length > 0 ) {
          return this.dataTablaInbiUno[ this.dataTablaInbiUno.length - 1 ].total
        }
        else {
          return 0
        }
      },

      metaFast() {
        if( this.dataTablaFastUno.length > 0 ) {
          return this.dataTablaFastUno[ this.dataTablaFastUno.length - 1 ].meta
        }
        else {
          return 0
        }
      },

      metaInbi() {
        if( this.dataTablaInbiUno.length > 0 ) {
          return this.dataTablaInbiUno[ this.dataTablaInbiUno.length - 1 ].meta
        }
        else {
          return 0
        }
      },

      avanceActualesInbi() {
        if( this.dataTablaInbiUno.length > 0 ) {
          return (( this.dataTablaInbiUno[ this.dataTablaInbiUno.length - 1 ].total / this.dataTablaInbiUno[ this.dataTablaInbiUno.length - 1 ].meta  )*100)
        }
        else {
          return 0
        }
      },

      ventasCambiosFast(){
        if( this.dataTablaFastUno.length > 0 ) {
          console.log( this.dataTablaFastUno )
          return this.dataTablaFastUno[ this.dataTablaFastUno.length - 1 ].total_fuera_ciclo
        }
        else {
          return 0
        }
      },

      ventasCambiosInbi(){
        if( this.dataTablaInbiUno.length > 0 ) {
          return this.dataTablaInbiUno[ this.dataTablaInbiUno.length - 1 ].total_fuera_ciclo
        }
        else {
          return 0
        }
      }
    },

    watch: {
      cicloInf () {
        if(this.cicloInf){
          var num_search = parseInt(this.cicloInf.ciclo.substr(5,3)) + 1
          for(const i in this.ciclos){
            var cadena_search = this.ciclos[i].ciclo.substr(0,8)
            if (cadena_search.search(num_search) != -1) {
              this.cicloSup = this.ciclos[i]
            }
          }

          this.fechaini = null
          this.fechafin = null
        }
      }
    },


    async created () {

      await this.initialize()

      // await this.getCiclos()
      // await this.initialize4()
      // await this.getNI()
    },

    methods: {

    	getCiclos () {
        this.cargar    = true
        this.ciclos    = []
        this.$http.get('kpi.ciclos.all').then(response=>{
          for(const i in response.data){
            if (!(response.data[i].ciclo.search('FE') != -1)) {
              if(response.data[i].ciclo.search('CICLO') != -1){
                this.ciclos.push(response.data[i])
              }
            }
          }
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { })
      },

      initializeComercial(){

        const payload = {
          fechaini: this.fechafin,
          fechafin: this.fechafin,
          escuela : 1
        }

        return this.$http.post("cambiar.prospecto.obtener.prospecto", payload ).then((response) => {
          this.prospectosInbi         = response.data.prospectos;
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { })
      },

      initializeComercialFast(){
        const payload = {
          fechaini: this.fechafin,
          fechafin: this.fechafin, // Restarle un día a la fecha de fin
          escuela : 2
        }

        return this.$http.post("cambiar.prospecto.obtener.prospecto", payload ).then((response) => {
          this.prospectosFast         = response.data.prospectos;
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => {  })
      },

      initializeRH(){
        this.vacantesExcelRH = []
        this.$http.get('organigrama.v2').then(response=>{
          let vacantes = []

        // Obtener las vacantes requeridas
          for( const i in response.data ){
            vacantes = vacantes.concat( response.data[i].vacantes_requeridos )
          }

          console.log( 'Vacantes sin plantel',vacantes.filter( el => !el.plantel ) )

          vacantes = vacantes.filter( el => el.plantel )

          this.vacantesExcelRH = vacantes


          // rhOcupacionInbi y rhOcupacionFast ( vamos a sacar por el plantel el match para saber si es inbi o fast )
          // Obtener las planteles
          let autorizadosInbi  = vacantes.filter( el => !el.plantel.match('FAST') && el.id_plantel != 13  )
          let autorizadosFast  = vacantes.filter( el => el.plantel.match('FAST') && el.id_plantel != 13 )
          let autorizadosCorpo = vacantes.filter( el => el.id_plantel == 13 )
          let autorizadosTodo = vacantes

          // Ahora scamos los que estan ocupados
          let ocupacionInbi  = vacantes.filter( el => !el.plantel.match('FAST') && el.id_plantel != 13 && el.id_trabajador )
          let ocupacionFast  = vacantes.filter( el => el.plantel.match('FAST') && el.id_plantel != 13 && el.id_trabajador )
          let ocupacionCorpo = vacantes.filter( el => el.id_plantel == 13 && el.id_trabajador )
          let ocupacionTodo = vacantes.filter( el => el.id_trabajador )

          // Ahora sacamos los que faltan
          let faltantesInbi  = vacantes.filter( el => !el.plantel.match('FAST') && el.id_plantel != 13 && !el.id_trabajador )
          let faltantesFast  = vacantes.filter( el => el.plantel.match('FAST') && el.id_plantel != 13 && !el.id_trabajador )
          let faltantesCorpo = vacantes.filter( el => el.id_plantel == 13 && !el.id_trabajador )
          let faltantesTodo = vacantes.filter( el => !el.id_trabajador )

          // ahora sacamos el porcentaje de ocupacion
          let percentOcupacionInbi  = ( ( ocupacionInbi.length / autorizadosInbi.length ) * 100 ).toFixed(2)
          let percentOcupacionFast  = ( ( ocupacionFast.length / autorizadosFast.length ) * 100 ).toFixed(2)
          let percentOcupacionCorpo = ( ( ocupacionCorpo.length / autorizadosCorpo.length ) * 100 ).toFixed(2)
          let percentOcupacionTodo = ( ( ocupacionTodo.length / autorizadosTodo.length ) * 100 ).toFixed(2)

          this.rhOcupacionInbi  = { percent_ocupacion: percentOcupacionInbi, ocupacion: ocupacionInbi, faltantes: faltantesInbi, autorizados: autorizadosInbi }
          this.rhOcupacionFast  = { percent_ocupacion: percentOcupacionFast, ocupacion: ocupacionFast, faltantes: faltantesFast, autorizados: autorizadosFast }
          this.rhOcupacionCorpo = { percent_ocupacion: percentOcupacionCorpo, ocupacion: ocupacionCorpo, faltantes: faltantesCorpo, autorizados: autorizadosCorpo }
          this.rhOcupacionTodo  = { percent_ocupacion: percentOcupacionTodo, ocupacion: ocupacionTodo, faltantes: faltantesTodo, autorizados: autorizadosTodo }

        }).catch(error=>{
          console.log( error )
          this.validError( error )
        }).finally( () => {  })
      },

      initializeTI(){
        let payload = {
    			fechaini: this.fechafin,
    			fechafin: this.fechafin,
    		}

        this.$http.post('tickets.ti.reporte', payload).then(response=>{
          const d = response.data || {}
          this.ti = {
            total_tickets: d.total_tickets,
            tickets_cerrados: d.tickets_cerrados,
            tickets_resueltos: d.tickets_resueltos,
            kpi_ti: d.kpi_ti,
            componentes: d.componentes || null
          }

        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => {  })
      },

      initializeMantenimiento(){
        let payload = {
    			fechaini: this.fechafin,
    			fechafin: this.fechafin,
    		}

        this.$http.post('tickets.ti.reporte.matenimiento', payload).then(response=>{
          // Tickets asignados a Angel LOPEZ (  )

          this.mantenimiento = {
            kpi_mantenimiento: response.data.kpi_mantenimiento != null
              ? response.data.kpi_mantenimiento
              : response.data.kpi_ti
          }

        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => {  })
      },

    	async initialize(){

        // Poner un loader general 
        this.cargar = true
    		// Iniciamos con RH, sacando los % de ocupación
        await this.initializeRH()

        // // Sacando los indicadores de comercial
        // await this.initializeComercial()
        // await this.initializeComercialFast()

        // // Sacando el indicador de TI
        // await this.initializeTI()

        // // Sacando el indicador de mantenimiento
        // await this.initializeMantenimiento()

        // // Departamento de finanzas
        // await this.initializeFinanzas()

        // // Departamento Operaciones $ Metamoney
        // await this.initializeMetamoney()

        // // Departamento de operaciones
        // await this.initializeOperaciones()

        // Departamento de operaciones - rol de clase
        // await this.initializeOperacionesRolClase()


        this.cargar = false
    	},

      async initializeMetamoney(){
        await this.$http.get('kpi.metamoney').then(response=>{
          this.metamoney = response.data
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => {  })
      },

      async initializeFinanzas( ){

        try {


          const response = await this.$http.get('kpi.finanzas');

          // Conversión a moneda
          this.finanzas = { 
            egresoInbi: response.data.egresoValidadoInbi,
            egresoFast: response.data.egresoValidadoFast,
            ingresoValidadoInbi: response.data.ingresoValidadoInbi,
            ingresoValidadoFast: response.data.ingresoValidadoFast,
          }

        } catch (error) {
          // 🔹 8. Manejo seguro del error (sin optional chaining)
          let msg = 'Ocurrió un error al procesar el archivo. Intente de nuevo.';

          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            msg = error.response.data.message;
          }

          this.validarError(msg);

        } finally {
          // 🔹 9. Apagamos el loader siempre
          // this.cargar = false;
        }

      },

      // Conversión a moneda mexicana
      convertirMoneda( monto ){
        return monto.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })
      },

      async initializeOperaciones(){
        await this.getSemanaCicloActualYProximo()
        await this.initializeOP()
        await this.datosDeRI( )
      },

      initializeOP () {
        this.cargar    = true
        var payload = { fechaini: this.fechafin, escuela: 1 }

        return this.$http.post('kpi.ventasmomento', payload ).then(response=>{
          this.metas            = response.data.metas
          

          this.id_ciclo               = response.data.id_ciclo
          this.id_ciclo_relacionado   = response.data.id_ciclo_relacionado
          this.ciclo                  = response.data.ciclo
         
          /*this.cargar = false*/
          this.getCiclo( )


        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { /*this.cargar = false*/ })
      },

      async datosDeRI() {

        //console.log('buscar ciclos')
        //console.log( this.ciclo )
        const payload = {"cicloPre":{"id_ciclo":406,"ciclo":"CICLO 01_26","fecha_inicio_ciclo":"2026-01-19 00:00:00","fecha_fin_ciclo":"2026-02-15 00:00:00","comentarios":null,"fecha_alta":"2025-01-05 10:45:00","activo_sn":1,"fecha_baja":null,"id_usuario_ultimo_cambio":28,"fecha_ultimo_cambio":"2026-02-12 11:41:36","ciclo_abierto_sn":1,"id_ciclo_relacionado":407,"activo_ventas":1,"costo_adultos":0,"costo_online":0},"cicloAct":{"id_ciclo":408,"ciclo":"CICLO 02_26","fecha_inicio_ciclo":"2026-02-16 00:00:00","fecha_fin_ciclo":"2026-03-15 00:00:00","comentarios":null,"fecha_alta":"2025-01-05 10:45:00","activo_sn":1,"fecha_baja":null,"id_usuario_ultimo_cambio":1,"fecha_ultimo_cambio":"2026-02-24 11:44:02","ciclo_abierto_sn":1,"id_ciclo_relacionado":409,"activo_ventas":0,"costo_adultos":50,"costo_online":30},"cicloSig":{"id_ciclo":431,"ciclo":"CICLO 03_26","fecha_inicio_ciclo":"2026-03-16 00:00:00","fecha_fin_ciclo":"2026-04-19 00:00:00","comentarios":"","fecha_alta":"2025-08-19 13:12:28","activo_sn":1,"fecha_baja":null,"id_usuario_ultimo_cambio":334,"fecha_ultimo_cambio":"2026-02-23 10:35:36","ciclo_abierto_sn":1,"id_ciclo_relacionado":430,"activo_ventas":1,"costo_adultos":0,"costo_online":0}}
        //console.log( payload )

        await this.$http.post('kpi.cantactual', payload ).then(response=>{
          this.resultadoRi = response.data
          this.resultadoRiFiltro = this.resultadoRi.riPlantelesInbi

          //console.log( response.data )
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => {  })
      },

      async initializeOperacionesRolClase(){

        let payload = {"id_ciclo":408,"ciclo":"CICLO 02_26","fecha_inicio_ciclo":"2026-02-16 00:00:00","fecha_fin_ciclo":"2026-03-15 00:00:00","comentarios":null,"fecha_alta":"2025-01-05 10:45:00","activo_sn":1,"fecha_baja":null,"id_usuario_ultimo_cambio":334,"fecha_ultimo_cambio":"2026-02-16 12:54:48","ciclo_abierto_sn":1,"id_ciclo_relacionado":409,"activo_ventas":1,"costo_adultos":50,"costo_online":30}

        await this.$http.post('rol.clases', payload ).then(response=>{
          let rol = response.data.respuesta

          //  id_unidad_negocio = 1 -> INBI
          //  id_unidad_negocio = 2 -> FAST
          let inbi = rol.filter( el => el.id_unidad_negocio == 1 )
          let fast = rol.filter( el => el.id_unidad_negocio == 2 )

          // Cuántas clases se dieron en el día ( hoy = fechafin - 1 day )
          // Slots 1, 2, 3: comparar con id_teacher. Slot 4: comparar con id_teacher_2
          const SLOTS_1_2_3 = ['lu1','lu2','lu3','ma1','ma2','ma3','mi1','mi2','mi3','ju1','ju2','ju3','vi1','vi2','vi3']
          const SLOTS_4 = ['lu4','ma4','mi4','ju4','vi4']

          let hoy = new Date( this.fechafin )
          hoy.setDate( hoy.getDate() - 1 )
          let hoyStr = hoy.toISOString().slice(0, 10)

          const tieneClaseHoy = (el) => [...SLOTS_1_2_3, ...SLOTS_4].some(s => el[`${s}_fecha`] == hoyStr)

          this.clasesInbiHoy = inbi.filter(tieneClaseHoy)
          this.clasesFastHoy = fast.filter(tieneClaseHoy)

          const contarCorrectas = (lista) => {
            let total = 0, correctas = 0
            for (const el of lista) {
              for (const slot of SLOTS_1_2_3) {
                if (el[`${slot}_fecha`] == hoyStr) {
                  total++
                  if (el[slot] == el.id_teacher) correctas++
                }
              }
              for (const slot of SLOTS_4) {
                if (el[`${slot}_fecha`] == hoyStr) {
                  total++
                  if (el[slot] == el.id_teacher_2) correctas++
                }
              }
            }
            return { total, correctas }
          }

          const inbiCounts = contarCorrectas(this.clasesInbiHoy)
          const fastCounts = contarCorrectas(this.clasesFastHoy)

          this.clasesInbiCorrectas = inbiCounts.correctas
          this.clasesInbiTotal = inbiCounts.total
          this.clasesFastCorrectas = fastCounts.correctas
          this.clasesFastTotal = fastCounts.total

        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => {  })
      },

      async getSemanaCicloActualYProximo () {
        this.dialogCarga = true
        await this.$http.get('kpi.dias.restantes.para.inscribirse')
        .then(response=>{

          this.segundaSemanaCicloActual   = this.sumarDias( response.data.inicio_ciclo_actual, 7 )
          this.segundoDomingoCicloProximo =  this.sumarDias( response.data.inicio_ciclo_siguiente, 7 )

          this.dialogCarga = false
        }).catch(error=>{console.log(error)})
      },

      sumarDias(fecha, dias) {
        const f = new Date(fecha);         // convertir a Date
        f.setDate(f.getDate() + dias);     // sumar los días
        return f;                          // devuelve un objeto Date
      },

      formatFecha(fecha) {
        if (!fecha) return '';

        const meses = [
          'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
          'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
        ];

        const f = new Date(fecha);
        const dia = f.getDate().toString().padStart(2, '0');
        const mes = meses[f.getMonth()];

        return `${dia} de ${mes}`;
      },

      diasFaltantes(fechaObjetivo) {
        const hoy = new Date();
        const objetivo = new Date(fechaObjetivo);

        const diffMs = objetivo - hoy; // diferencia en milisegundos
        const dias = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

        return dias;
      },

      getCiclo () {
        this.dialogCarga = true
        this.$http.get('kpi.inscripciones.total.fast/' + this.id_ciclo_relacionado).then(response=>{
          this.dataTablaFastUno = response.data
          
          let metaTotal = 0
          let faltanTotal = 0
          let hayFast = 0
          let totalContactos = 0
          let total_completos = 0
          let total_incompletos = 0
          let total_merca = 0
          let total_sucursal = 0
          //let total_fuera_ciclo = 0

          for( const i in this.dataTablaFastUno ){

            const { id_plantel, total } = this.dataTablaFastUno[i]

            const existeMeta = this.metas.find( el => el.id_plantel == id_plantel )

            let meta = existeMeta ? existeMeta.meta : 0

            metaTotal += meta
            hayFast   += total

            let faltan = meta - total
            this.dataTablaFastUno[i]['faltan'] = faltan
            this.dataTablaFastUno[i]['meta'] = meta

          }

          // Ordenar el arreglo por la propiedad 'total' de forma descendente (mayor a menor)
          this.dataTablaFastUno.sort((a, b) => b.total - a.total);

          // Asignar una posición ('rank') a cada plantel basada en su posición en el arreglo ordenado
          this.dataTablaFastUno.forEach((plantel, index) => {
            plantel.position = index + 1; // La posición comienza en 1
            totalContactos += plantel.totalContactos
            total_completos += plantel.total_completos
            total_incompletos += plantel.total_incompletos
            total_merca += plantel.total_merca
            total_sucursal += plantel.total_sucursal
          });


          var payload = {
            plantel: 'Total',
            total: 0,
            total_fuera_ciclo: 0,
            total_completos: 0,
            total_incompletos: 0,
            total_sucursal: 0,
            total_merca: 0,
            prospectos: [],
            vendedoras: [],
            completos: [],
            incompletos: [],
            merca: [],
            sucursal: [],
          }

          // console.clear()

          let vendedorasCompletas = []

          for(const i in this.dataTablaFastUno){

            const { vendedoras } = this.dataTablaFastUno[i]

            vendedorasCompletas = vendedorasCompletas.concat( vendedoras )

            let total_fuera_ciclo = 0
            if( this.dataTablaFastUno[i].quienVendio ){

              // Sumar total quien vendio
              this.dataTablaFastUno[i].quienVendio.map( q => {
                total_fuera_ciclo += +q.total_registros_diferente_ciclo
              })
              
              this.dataTablaFastUno[i].total_fuera_ciclo= total_fuera_ciclo

            }
            
            payload.total += this.dataTablaFastUno[i].total
            payload.total_fuera_ciclo += +total_fuera_ciclo
            payload.total_completos += this.dataTablaFastUno[i].total_completos
            payload.total_incompletos += this.dataTablaFastUno[i].total_incompletos
            payload.total_sucursal += this.dataTablaFastUno[i].total_sucursal
            payload.total_merca += this.dataTablaFastUno[i].total_merca
            payload.prospectos.push( ...this.dataTablaFastUno[i].prospectos )
            // payload.vendedoras.push( this.dataTablaFastUno[i].vendedoras )
            payload.completos.push( ...this.dataTablaFastUno[i].completos )
            payload.incompletos.push( ...this.dataTablaFastUno[i].incompletos )
            payload.merca.push( ...this.dataTablaFastUno[i].merca )
            payload.sucursal.push( ...this.dataTablaFastUno[i].sucursal )
          }

          // Sacar vendedoras unicas y retornar un arreglo de objetos con el nombre_completo y el total_contactos, y luegoooo el campo total_contactos, se debe ir sumando por vendedora
          const vendedorasUnicas = [...new Set(vendedorasCompletas.map(v => v.nombre_completo))]
          let vendedorasUnicasObjetos = []
          for( const i in vendedorasUnicas ){
            vendedorasUnicasObjetos.push({ 
              nombre_completo: vendedorasUnicas[i], 
              total_contactos: vendedorasCompletas.filter(v => v.nombre_completo == vendedorasUnicas[i]).reduce((prev, curr) => prev + curr.total_contactos, 0), 
              usuario_asignado: vendedorasCompletas.find(v => v.nombre_completo == vendedorasUnicas[i]).usuario_asignado
            })
          }

          // this.totalFast =  payload.total
          this.dataTablaFastUno.push({...payload,
            totalContactos,
            total_completos,
            total_incompletos,
            total_merca,
            total_sucursal,
            faltan: metaTotal - hayFast,
            meta: metaTotal,
            vendedoras: vendedorasUnicasObjetos
          })
          
            

          totalContactos = 0;
          total_completos=0
          total_incompletos=0
          total_merca=0
          total_sucursal=0

          this.$http.get('kpi.inscripciones.total.inbi/' + this.id_ciclo).then(response=>{

            this.dataTablaInbiUno = response.data

            console.log( 'tabla INBI Uno' )
            console.log( response.data )

            let metaTotalI = 0
            let faltanTotalI = 0
            let hayFastI = 0
            let vendedorasCompletasInbi = []

            for( const i in this.dataTablaInbiUno ){

              const { id_plantel, total } = this.dataTablaInbiUno[i]

              const existeMeta = this.metas.find( el => el.id_plantel == id_plantel )

              let meta = existeMeta ? existeMeta.meta : 0

              metaTotalI += meta
              hayFastI   += total

              let faltan = meta - total
              this.dataTablaInbiUno[i]['faltan'] = faltan
              this.dataTablaInbiUno[i]['meta'] = meta
            }

            // Ordenar el arreglo por la propiedad 'total' de forma descendente (mayor a menor)
            this.dataTablaInbiUno.sort((a, b) => b.total - a.total);

            // Asignar una posición ('rank') a cada plantel basada en su posición en el arreglo ordenado
            this.dataTablaInbiUno.forEach((plantel, index) => {
              plantel.position = index + 1; // La posición comienza en 1
              totalContactos += plantel.totalContactos
              total_completos += plantel.total_completos
              total_incompletos += plantel.total_incompletos
              total_merca += plantel.total_merca
              total_sucursal += plantel.total_sucursal
            });


            var payload = {
              plantel: 'Total',
              total:0,
              total_fuera_ciclo: 0,
              total_completos:0,
              total_incompletos:0,
              total_sucursal: 0,
              total_merca: 0,
              prospectos: [],
              completos: [],
              incompletos: [],
              merca: [],
              sucursal: [],
            }
            for(const i in this.dataTablaInbiUno){

              const { vendedoras } = this.dataTablaInbiUno[i]

              vendedorasCompletasInbi = vendedorasCompletasInbi.concat( vendedoras )

              let total_fuera_ciclo = 0
              if( this.dataTablaInbiUno[i].quienVendio ){

                // Sumar total quien vendio
                this.dataTablaInbiUno[i].quienVendio.map( q => {
                  total_fuera_ciclo += +q.total_registros_diferente_ciclo
                })
                
                this.dataTablaInbiUno[i].total_fuera_ciclo= total_fuera_ciclo

              }

              // console.log( 'TOTALINBI' )
              // console.log( total_fuera_ciclo )

              payload.total += this.dataTablaInbiUno[i].total
              payload.total_fuera_ciclo += +total_fuera_ciclo
              payload.total_completos += this.dataTablaInbiUno[i].total_completos
              payload.total_incompletos += this.dataTablaInbiUno[i].total_incompletos
              payload.total_sucursal += this.dataTablaInbiUno[i].total_sucursal
              payload.total_merca += this.dataTablaInbiUno[i].total_merca
              payload.prospectos.push( ...this.dataTablaInbiUno[i].prospectos )
              payload.completos.push( ...this.dataTablaInbiUno[i].completos )
              payload.incompletos.push( ...this.dataTablaInbiUno[i].incompletos )
              payload.merca.push( ...this.dataTablaInbiUno[i].merca )
              payload.sucursal.push( ...this.dataTablaInbiUno[i].sucursal )
            }

            // Sacar vendedoras unicas y retornar un arreglo de objetos con el nombre_completo y el total_contactos, y luegoooo el campo total_contactos, se debe ir sumando por vendedora
            const vendedorasUnicasInbi = [...new Set(vendedorasCompletasInbi.map(v => v.nombre_completo))]
            let vendedorasUnicasObjetosInbi = []
            for( const i in vendedorasUnicasInbi ){
              vendedorasUnicasObjetosInbi.push({ 
                nombre_completo: vendedorasUnicasInbi[i], 
                total_contactos: vendedorasCompletasInbi.filter(v => v.nombre_completo == vendedorasUnicasInbi[i]).reduce((prev, curr) => prev + curr.total_contactos, 0), 
                usuario_asignado: vendedorasCompletasInbi.find(v => v.nombre_completo == vendedorasUnicasInbi[i]).usuario_asignado
              })
            }
            // this.totalInbi =  payload.total
            this.dataTablaInbiUno.push({...payload,
              totalContactos,
              total_completos,
              total_incompletos,
              total_merca,
              total_sucursal,
              faltan: metaTotalI - hayFastI, meta: metaTotalI,
              vendedoras: vendedorasUnicasObjetosInbi
            })
            this.dialogCarga = false
          }).catch(error=>{console.log(error)})
        }).catch(error=>{console.log(error)})
      },
    	


      abrirDialog( value ){
        this.alumnos = value
        this.dialogAlumnos = true
      },

      exportar(){
        this.exportarData()
      },

      s2ab2(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
      },

    },
  }
</script>

<style scoped>
.ocupacion-card {
  width: 100%;
  max-width: 100%;
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ocupacion-row {
  width: 70%;
  max-width: 80%;
}
.ocupacion-col {
  padding: 10px !important;
}
.ocupacion-label {
  margin-top: 6px;
  font-size: 0.85rem;
  white-space: nowrap;
  text-align: center;
  min-height: 1.2em;
}
</style>